import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { User } from "../App";

function Detail() {

    const user = useContext(User);
    const location = useLocation();
    const data = location.state?.data

    return (
        <div className="detail">
            <div className="detail-nav">
                <div className="detail-nav-left ">
                    <img src="https://static-assets.pixelied.com/logos-v2/px-logo-purple.svg" />
                    <h3>Weekly</h3>
                </div>
                <div className="detail-nav-right">
                    <p>{user?.displayName}</p>
                    <img src={user?.photoURL} />
                </div>
            </div>
            <h4>{user?.metadata?.creationTime}</h4>
            <h1>{data?.title}</h1>
            <img src={data?.photoURL} />
            <p>{data?.content}</p>
        </div>
    );
}

export default Detail;
